import { Phone, MessageCircle } from "lucide-react";
import { BUSINESS, waLink } from "../lib/constants";

export default function FloatingActions() {
  const waMsg = "Hello Jaiswal Tent House! I would like to enquire about your services.";
  return (
    <>
      {/* Desktop floating WhatsApp bubble */}
      <a
        href={waLink(waMsg)}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="floating-whatsapp-desktop"
        aria-label="Chat on WhatsApp"
        className="animate-pulse-ring fixed bottom-7 right-7 z-40 hidden h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-[0_10px_30px_rgba(37,211,102,0.4)] transition-transform hover:scale-110 md:flex"
      >
        <MessageCircle className="h-6 w-6" />
      </a>

      {/* Mobile bottom action bar */}
      <div className="fixed inset-x-0 bottom-0 z-50 grid grid-cols-2 border-t border-gold/25 bg-[#0A0908]/95 backdrop-blur-xl md:hidden [padding-bottom:env(safe-area-inset-bottom)]">
        <a
          href={BUSINESS.phoneHref}
          data-testid="floating-call-mobile"
          className="flex items-center justify-center gap-2 py-4 text-sm font-semibold text-[#14120E]"
          style={{ background: "linear-gradient(135deg,#F3E5AB 0%,#D4AF37 100%)" }}
        >
          <Phone className="h-4 w-4" /> Call Now
        </a>
        <a
          href={waLink(waMsg)}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="floating-whatsapp-mobile"
          className="flex items-center justify-center gap-2 bg-[#25D366] py-4 text-sm font-semibold text-[#083b1d]"
        >
          <MessageCircle className="h-4 w-4" /> WhatsApp Us
        </a>
      </div>
    </>
  );
}
